import firebase from 'firebase'
import { Observable } from '@reactivex/rxjs'
import { fromJS } from 'immutable'

const app = firebase.initializeApp({
  apiKey: process.env.API_KEY,
  authDomain: process.env.AUTH_DOMAIN,
  databaseURL: process.env.DATABASE_URL,
  projectId: process.env.PROJECT_ID,
  storageBucket: process.env.STORAGE_BUCKET,
  messagingSenderId: process.env.MESSAGING_SENDER,
})

const samples = app
  .database()
  .ref('/samples')
  .orderByChild('iteration')
  .limitToLast(10)

export const update$ = Observable.create(observer => {
  const update = data => {
    observer.next(state =>
      state.set('samples', state.get('samples').push(fromJS(data.val())))
    )
  }
  samples.on('child_added', update)
  return () => samples.off('child_added', update)
})



// WEBPACK FOOTER //
// ./firebase-init.js